const enum ClaimFlowType {
  pay = 'Pay Anyone',
  receive = 'P2P Request Payment',
}

export default ClaimFlowType;
